import React, { useRef } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Checkbox } from '@mui/material';
import clsx from "clsx";
import customSortIcon from "../Icons/sortIcon";
import sortIconUp from "../Icons/sortIconUp";
import customStyles from "../../../../assets/styles/customStyles";


export default function PrimaryTable(props) {
    const { heads, component, sortOrder, sortBy, onRequestSort, customClasses,
        onSelected, details = [], selected = [], extraTable } = props;
    const classes = customStyles();
    const tableEl = useRef();

    const onSelectAllClick = (e) => {
        if (e.target.checked) {
            const newSelecteds = details && details.map((n) => n.id);
            onSelected(newSelecteds);
            return;
        }
        onSelected([]);
    };

    return (
        <TableContainer ref={tableEl} className={clsx(customClasses, classes.tablecontain)}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {heads.map((head, i) => {
                            return (
                                <TableCell key={i} className={clsx(head.key, classes.tablealign, { [classes.sortColParent]: head.sorting }, { [classes.amountRightAlign]: head.amount }, { [classes.textAlignRight]: head.rightAlign }, { [classes.textAlignCenter]: head.centerAlign }, { [classes.textAlignLeft]: head.leftAlign })}>
                                    {
                                        head.sorting ? <TableSortLabel
                                            className={classes.sortCol}
                                            IconComponent={sortOrder === 'desc' && sortBy === head.key ? sortIconUp : customSortIcon}
                                            direction={sortOrder}
                                            onClick={() => onRequestSort(head.key, sortOrder === 'asc' ? 'desc' : 'asc')}
                                        >
                                            {head.name}
                                        </TableSortLabel> : head.key === 'checkbox' ?
                                            <Checkbox
                                                color="primary"
                                                indeterminate={selected.length > 0 && selected.length < details.length}
                                                checked={details.length > 0 && selected.length === details.length}
                                                onChange={(e) => onSelectAllClick(e)}
                                                inputProps={{
                                                    'aria-label': 'select all desserts',
                                                }}
                                            /> : head.actionWidth ? <span style={{ width: head.actionWidth }} className={classes.actionColumn}>{head.name}</span> : head.name
                                    }
                                </TableCell>
                            )
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {component}
                </TableBody>
            </Table>
            {
                extraTable && extraTable
            }
        </TableContainer>
    );
}
